// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — zone-row.classic.js, новая — zone-row.cp.js
import { isCp } from 'libs/design';
import * as classic from './zone-row.classic';
import * as cp from './zone-row.cp';

export const ZoneRow = isCp ? cp.ZoneRow : classic.ZoneRow;
